import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGIN_UPDATE,
  LOGOUT_USER,  
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  LOGIN_USER_BY_TOKEN
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginUserByToken = (user, history) => {
  return {
    type: LOGIN_USER_BY_TOKEN,
    payload: { user, history },
  }
}

export const loginSuccess = (userFull, profile={} ) => {

  return {
    type: LOGIN_SUCCESS,
    payload: {user : userFull, profile}
  }
}

export const loginUpdate = (profile={} ) => {

  return {
    type: LOGIN_UPDATE,
    payload: {profile}
  }
}


export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}
